"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

const DELAY_SECONDS = 3;

// "다음 문제" 링크. autoAdvance가 켜져 있으면 버튼에 남은 초를 3→2→1로 보여주다가
// 0이 되면 자동으로 이동한다. 사용자가 그 전에 직접 클릭해도 정상 동작한다.
export function AutoAdvanceLink({
  href,
  label,
  autoAdvance,
}: {
  href: string;
  label: string;
  autoAdvance: boolean;
}) {
  const router = useRouter();
  const [secondsLeft, setSecondsLeft] = useState(DELAY_SECONDS);

  useEffect(() => {
    if (!autoAdvance) return;
    const interval = setInterval(() => {
      setSecondsLeft((s) => s - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [autoAdvance]);

  useEffect(() => {
    if (autoAdvance && secondsLeft <= 0) router.push(href);
  }, [autoAdvance, secondsLeft, href, router]);

  return (
    <Link
      href={href}
      className="ml-auto w-fit rounded-lg bg-foreground px-5 py-2.5 font-medium text-background transition hover:opacity-90"
    >
      {label}
      {autoAdvance && secondsLeft > 0 && ` · ${secondsLeft}초 후 자동 이동`}
    </Link>
  );
}
